import React from 'react'
import { useTranslation } from "react-i18next"

function ReviewBanner({
  onLogoClick,
  displayLogo = true,
  logoImgSrc,
  groupImgSrc,
  groupId,
  groupType,
  driverName,
  reference,
  display
}) {
  const { t } = useTranslation();

  return (
    <div className="resumo-header row banner-height">
      <div className="col-6 pr-0 align-self-end">
        {displayLogo &&
          <div className='logo' onClick={onLogoClick}>
            <img src={logoImgSrc} alt="Guerin" className="img-fluid pt-3 pb-3" />
          </div>
        }
        <img src={groupImgSrc} alt={`vehicle ${groupId}`} className="img-fluid" />
      </div>
      <div className="col-6 text-right">
        <div className="greet">
          <span className="name d-block"><b>{t('hi')} {driverName}</b></span>
          <small>{t('thisIsYourReservation')} {reference}</small>
        </div>
        <div className="detail">
          {t('group')} {groupId}
          <br />
          <b>{groupType}</b>
          <br />
          {t('orSimilar')}
        </div>
      </div>
    </div>
  )
}

export default ReviewBanner